export default __webpack_public_path__ + "static/media/HDTX_Annual Report 2025.9ceb13f5.pdf";